import { apiKeysId, type ApiKeysId } from "./ApiKeys";
import { projectsId, type ProjectsId } from "./Projects";
import { environmentsId, type EnvironmentsId } from "./Environments";
import type { ColumnType, Selectable, Insertable, Updateable } from "kysely";
import { z } from "zod";

/**
 * Represents the table public.api_key_projects
 * @uniqueConstraints {"unique_api_key_project_environment":{"name":"unique_api_key_project_environment","isPrimary":false,"isUnique":true,"columns":[{"name":"api_key","definition":"api_key","predicate":null},{"name":"project_id","definition":"project_id","predicate":null},{"name":"environment_id","definition":"environment_id","predicate":null}]}}
 */
export default interface ApiKeyProjectsTable {
  apiKey: ColumnType<ApiKeysId, ApiKeysId, ApiKeysId>;

  projectId: ColumnType<ProjectsId, ProjectsId, ProjectsId>;

  environmentId: ColumnType<EnvironmentsId | null, EnvironmentsId | null, EnvironmentsId | null>;
}

export type ApiKeyProjects = Selectable<ApiKeyProjectsTable>;

export type NewApiKeyProjects = Insertable<ApiKeyProjectsTable>;

export type ApiKeyProjectsUpdate = Updateable<ApiKeyProjectsTable>;

export const apiKeyProjects = z.object({
  apiKey: apiKeysId,
  projectId: projectsId,
  environmentId: environmentsId.nullable(),
});

export const apiKeyProjectsInitializer = z.object({
  apiKey: apiKeysId,
  projectId: projectsId,
  environmentId: environmentsId.optional().nullable(),
});

export const apiKeyProjectsMutator = z.object({
  apiKey: apiKeysId.optional(),
  projectId: projectsId.optional(),
  environmentId: environmentsId.optional().nullable(),
});

// ── constraints for ApiKeyProjects ─────────────────────────────────
export const ApiKeyProjectsConstraints = {
  unique_api_key_project_environment: {
    name: "unique_api_key_project_environment",
    isPrimary: false,
    isUnique: true,
    columns: [
      { name: "api_key", definition: "api_key", predicate: null },
      { name: "project_id", definition: "project_id", predicate: null },
      { name: "environment_id", definition: "environment_id", predicate: null },
    ],
  },
} as const;
export type ApiKeyProjectsConstraintsType = typeof ApiKeyProjectsConstraints;
